import { useSelector } from 'react-redux';

import { offerPreparedPhonesSelector } from '../../selectors/offerData/offer/offerPreparedPhonesSelector';
import { IState } from '../../store';

export function useOfferPreparedPhonesSelector(): string[] {
  return useSelector<IState, string[]>(offerPreparedPhonesSelector);
}
